import CollaboAdmin from './CollaboAdmin';

export default CollaboAdmin;
